import React from "react";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Testimonials.css";

const testimonials = [
  {
    name: "Omer Abdulla",
    role: "Real Estate Client, Dubai (UAE)",
    quote:
      "Oglitz helped us build a strong digital presence with a clean, modern website that perfectly represents our real estate brand in Dubai.",
    rating: 5,
  },
  {
    name: "Reema Steel",
    role: "Steel Fabrication & Kitchen Equipment, Dubai",
    quote:
      "Professional execution and timely delivery. Our corporate website now clearly showcases our products and industrial capabilities.",
    rating: 5,
  },
  {
    name: "Ardh Al Safari",
    role: "Real Estate Company, Dubai",
    quote:
      "Excellent communication and execution. The Oglitz team delivered exactly what our business needed for online inquiries.",
    rating: 5,
  },
  {
    name: "Abraj Real Estate",
    role: "Property Brokerage, Dubai",
    quote:
      "A smooth experience from planning to launch. The website design is modern, responsive, and conversion-focused.",
    rating: 5,
  },
  {
    name: "Bharat Jalpan",
    role: "Restaurant Business, Dubai",
    quote:
      "Oglitz gave our brand a professional online identity that truly reflects our food business and values.",
    rating: 5,
  },
  {
    name: "Burj Al Yarmouk Industries",
    role: "Industrial & Manufacturing Client, UAE",
    quote:
      "Strong technical understanding and corporate-level delivery. Highly recommended for industrial websites.",
    rating: 5,
  },
  {
    name: "Trio Line Real Estate",
    role: "Real Estate Firm, Dubai",
    quote:
      "The team delivered a clean and professional website with excellent lead inquiry integration.",
    rating: 5,
  },
  {
    name: "Trippr",
    role: "Vehicle Rental Startup, India",
    quote:
      "Oglitz played a key role in shaping our platform and delivering a smooth user experience for our customers.",
    rating: 5,
  },
  {
    name: "Nautika",
    role: "Online Ferry Booking Platform, India",
    quote:
      "Reliable development partner with a strong focus on performance and scalability.",
    rating: 5,
  },
  {
    name: "Octavian GR",
    role: "Enterprise Client, United Kingdom",
    quote:
      "Professional, secure, and enterprise-ready development. The collaboration was smooth and efficient.",
    rating: 5,
  },
  {
    name: "Confidential Client",
    role: "NDA Project, Germany",
    quote:
      "Oglitz handled our project with complete confidentiality and delivered a robust, scalable solution.",
    rating: 5,
  },
  {
    name: "Foxey",
    role: "Video Streaming Platform, India",
    quote:
      "Impressive app development quality with great attention to performance and user experience.",
    rating: 5,
  },
  {
    name: "Mr Gekonge",
    role: "Social Media App, Kenya",
    quote:
      "The team understood our vision and converted it into a scalable social media application.",
    rating: 5,
  },
  {
    name: "Welth Clinic",
    role: "Real Estate Channel Partner, Lucknow",
    quote:
      "Great support and delivery. The website helped us generate quality leads efficiently.",
    rating: 5,
  },
  {
    name: "Fibble",
    role: "Government Affiliated Project, Punjab",
    quote:
      "Structured development approach and strong technical execution for a government-scale project.",
    rating: 5,
  },
  {
    name: "Maya",
    role: "Business Client, Bahrain",
    quote:
      "A reliable technology partner delivering modern web solutions with clarity and professionalism.",
    rating: 5,
  },
  {
    name: "Ahmed Hady",
    role: "International Client, Egypt",
    quote:
      "Very professional team with clear communication and high-quality delivery.",
    rating: 5,
  },
  {
    name: "Crypto App Client",
    role: "Blockchain Startup, USA",
    quote:
      "Strong understanding of modern technologies and secure application development.",
    rating: 5,
  },
  {
    name: "John Madia",
    role: "Business Client, Brazil",
    quote:
      "Efficient delivery, great support, and a solid technical foundation.",
    rating: 5,
  },
  {
    name: "Nicolas Gou",
    role: "Technology Client, Lithuania",
    quote: "Clean architecture, smooth collaboration, and excellent results.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="oglitz-testimonials">
      <div className="oglitz-testimonials-inner">
        <span className="oglitz-testimonials-badge">Client Testimonials</span>

        <h2 className="oglitz-testimonials-title">
          Trusted by <span>Global Clients</span>
        </h2>

        <p className="oglitz-testimonials-desc">
          Premium feedback from clients across industries worldwide.
        </p>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="oglitz-testimonials-swiper"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="oglitz-testimonial-card">
                <FaQuoteLeft className="quote-icon" />

                <p className="testimonial-text">{item.quote}</p>

                <div className="testimonial-rating">
                  {[...Array(item.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>

                <div className="testimonial-author">
                  <strong>{item.name}</strong>
                  <span>{item.role}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
